import { FC, PropsWithChildren } from 'react';

import { Modal } from '../modal/modal';
import { L12nText } from '../text/L12nText';

interface SettingsModalProps extends PropsWithChildren {
  isOpen: boolean;
  onClose: () => void;
}

export const SettingsModal: FC<SettingsModalProps> = ({ isOpen, onClose, children }) => {
  return (
    <Modal
      open={isOpen}
      large
      onClose={onClose}
      fullScreenNoClose
      floating
      draggable
      grow
      title={<L12nText tk="SETTINGS" />}
    >
      {children}
    </Modal>
  );
};
